import styled from "styled-components";
import { withFilteredProps } from "@components/withFilteredProps/withFilteredProps";

const _ContentWrapper = styled.div`
  max-width: ${props => props.maxWidth || "none"};
  margin: 0 auto;
  padding: 30px 0 10px;
  ${props => !!props.paddingTop ? `padding-top: ${props.paddingTop}px;` : ""}
`;
export const ContentWrapper = withFilteredProps(_ContentWrapper);
export default ContentWrapper;